<template>
  <section ref="trigger"
    class="form-section"
    :class="{ 'form-section_overseas': overseas }">
    <div class="form-section__inner">
      <div class="form-section__image">
        <img v-if="image"
          ref="backgroundImage"
          class="lazy"
          :data-src="image"
          alt="Изображение №1" />
        <img v-else
          src="@/assets/images/form-2.jpg"
          alt="Изображение №2">
        <div class="form-section__text-block">
          <div class="form-section__title" v-html="title"></div>
        </div>
      </div>
      <form ref="feedbackForm"
        class="form-section__form"
        @submit.prevent="submitForm">
        <div v-if="text" class="form-section__text">
          {{ text }}
        </div>
        <template v-if="!overseas && $route.path !== '/partners'">
          <div class="form-section__row">
            <FormRadio :key="updateKey"
              class="form-section__radio"
              :is-dark="true"
              name="form"
              value="sell"
              :checked="form.sell_or_rent === 'Продать'"
              @change="sell">
              Продать
            </FormRadio>
            <FormRadio :key="updateKey"
              :checked="form.sell_or_rent === 'Купить'"
              class="form-section__radio"
              :is-dark="true"
              name="form"
              value="rent"
              @change="rent">
              Купить
            </FormRadio>
          </div>
        </template>
        <div class="form-section__row">
          <FormInput :key="updateKey"
            v-model="form.name"
            class="form-section__input"
            :class="{ _error: invalid && !form.name }"
            :is-dark="true"
            name="name"
            placeholder="Ваше имя*"
            @blur="onInput" />
          <FormInput :key="phoneKey"
            ref="phoneInput"
            v-model="form.phone"
            class="form-section__input"
            :is-dark="true"
            type="tel"
            name="phone"
            placeholder="Ваш телефон*"
            :class="{ _error: invalid && !form.phone }"
            @blur="onPhoneInput" />
        </div>
        <div v-if="$route.path === '/partners'" class="form-section__row form-section__row_add">
          <FormInput :key="updateKey"
            v-model="form.email"
            class="form-section__input"
            :class="{ _error: invalid && !form.email }"
            :is-dark="true"
            type="email"
            name="email"
            placeholder="Ваш e-mail*"
            @blur="onInput" />
          <FormInput :key="updateKey"
            v-model="form.company"
            class="form-section__input"
            :is-dark="true"
            name="company"
            placeholder="Название компании*"
            :class="{ _error: invalid && !form.company }"
            @blur="onInput" />
        </div>
        <FormCheck :key="updateKey"
          v-model="form.check"
          :class="{ _error: invalid && !checkIsValid }"
          class="form-section__check"
          :is-dark="true"
          @click="onChange">
          Согласие на обработку
          <a href="/politika"
            target="_blank">персональных данных </a>
        </FormCheck>
        <div class="form-section__row">
          <AppButton :to-send="true"
            :sending="sending"> Отправить заявку </AppButton>
        </div>
        <!--    <div
          v-if="invalid"
          class="_invalid"
        >
          Есть ошибки!
        </div> -->
      </form>
      <!-- <div class="form-section__background-image">
        <img v-if="image"
          ref="backgroundImage"
          class="lazy"
          :data-src="image"
          alt="Изображение №3" />
        <img v-else
          ref="backgroundImage"
          class="lazy"
          :data-src="require(`@/assets/images/content/form-section.jpg`)"
          alt="Изображение №4" />
      </div> -->
      <teleport v-if="isOpenPopupSuccessfully"
        to="body">
        <PopupSuccessfully @popup-close="isOpenPopupSuccessfully = false" />
      </teleport>
    </div>
  </section>
</template>

<script>
import FormRadio from "./form/FormRadio.vue";
import FormInput from "./form/FormInput.vue";
import FormCheck from "./form/FormCheck.vue";
import AppButton from "@/components/ui/AppButton.vue";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import PopupSuccessfully from "@/components/PopupSuccessfully.vue";

gsap.registerPlugin(ScrollTrigger);

export default {
  name: "FormSection",
  components: { FormRadio, FormInput, FormCheck, AppButton, PopupSuccessfully },

  props: {
    title: {
      type: String,
      default: "",
    },
    text: {
      type: String,
      default: "",
    },
    image: {
      type: String,
      default: null,
    },
    formSection: {
      type: Object,
      default: () => { },
    },
    nameIsValid: {
      type: String,
      default: null,
    },
    phoneIsValid: {
      type: String,
      default: null,
    },
    checkIsValid: {
      type: Boolean,
      default: null,
    },
    overseas: {
      type: Boolean,
      default: false,
    },
    regions: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      form: {
        sell_or_rent: "Продать",
        page: window.location.href,
      },
      sending: false,
      invalid: false,
      errors: [],
      formIsCheck: false,
      phoneKey: 0,
      updateKey: 0,
      isOpenPopupSuccessfully: false,
    };
  },

  /*   mounted() {
      this.backgroundImageAnimation();
    }, */

  methods: {
    isValid() {
      const nameIsValid = !!this.form.name;
      const phoneIsValid = !!this.form.phone;
      const checkIsValid = !!this.formIsCheck;

      if (nameIsValid && phoneIsValid && checkIsValid) return true;
    },

    sell() {
      this.form.sell_or_rent = "Продать";
    },

    rent() {
      this.form.sell_or_rent = "Купить";
    },

    onChange() {
      this.formIsCheck = !this.formIsCheck;
    },

    onInput(event) {
      const inputValue = event.target.value;
      const inputLength = inputValue.length;

      if (inputLength < 1) {
        this.form.name = null;

        if (this.$route.path === '/partners') {
          this.form.email = null;
          this.form.company = null;
        }
      }
    },

    onPhoneInput(event) {
      const inputValue = event.target.value;
      const inputLength = inputValue.length;

      if (inputLength < 18) {
        this.phoneKey += 1;
        this.form.phone = null;
      }
    },

    submitForm() {
      if (this.isValid()) {
        this.errors = [];
        this.invalid = false;
        this.sending = true;

        var url = this.overseas ? '/api/sendCountriesForm' : '/api/sendFeedback?type=sell_or_rent';

        if(this.regions){
          var url = '/api/sendRegionsFeedback';
        }

        if (this.overseas) {
          delete this.form.sell_or_rent;
        }

        this.axios
          .post(url, this.form)
          .then((response) => {
            if (response.status) {
              let form = this.form;

              form = {};

              Object.keys(form).forEach(function (key) {
                form[key] = "";
              });

              this.formIsCheck = false;
              this.sending = false;
              this.clearForm();
              this.updateKeyValue();
              this.phoneKey += 1;
              this.form.phone = null;
              this.form.name = null;
              
              this.isOpenPopupSuccessfully = true;

              if (this.$route.path === '/partners') {
                this.form.email = null;
                this.form.company = null;
              }
            }
          })
          .catch((error) => {
            this.sending = false;
            /* this.errors = error.response.data.errors; */
          });
      } else {
        this.invalid = true;
      }

      setTimeout(() => {
        this.isOpenPopupSuccessfully = false;
      }, 4000);
    },

    clearForm() {
      const form = this.$refs.feedbackForm;
      const formInputs = form.querySelectorAll("._fixed-label");

      form.reset();

      formInputs.forEach((input) => {
        input.classList.remove("_fixed-label");
      });
    },

    updateKeyValue() {
      this.updateKey += 1;
    },
  },
};
</script>

<style lang="scss" scoped>
.form-section {
  $that: &;

  position: relative;
  // min-height: 442px;
  border-top-left-radius: 240px;
  background-color: #f6f6f6;
  overflow: hidden;

  @include phone {
    border-top-left-radius: 70px;
  }

  &_overseas {
    min-height: unset;

    .form-section__form {
      height: unset;
    }
  }

  &__inner {
    display: flex;

    @include laptop {
      flex-direction: column;
    }
  }

  &__image {
    position: relative;
    display: flex;
    width: 100%;
    height: 568px;

    & img {
      position: absolute;
      object-fit: cover;
      object-position: left top;
      max-width: none !important;
      width: 100%;
      height: 100% !important;
      filter: brightness(0.7);
    }

    @include phone {
      height: 250px;
    }
  }

  &__row {
    display: flex;
    gap: 10px;
    justify-content: center;

    @include phone {
      gap: 8px;
    }

    &+& {
      margin-top: 38px;

      &_add {
        margin-top: 12px;
      }

      @include phone {
        margin-top: 28px;
      }
    }

    
  }

  &__text-block {
    color: $white;
    position: absolute;
    z-index: 2;
    align-self: flex-end;
    max-width: 800px;
    padding-left: 176px;

    @include tablet {
      padding-left: 30px;
    }
  }

  &__title {
    font-size: 65px;
    line-height: 75px;
    padding-bottom: 102px;

    @include tablet {
      font-size: 34px;
      line-height: 120%;
      padding-bottom: 30px;
    }
  }

  &__text {
    font-size: 20px;
    line-height: 28px;
    margin-bottom: 64px;
    max-width: 430px;
    color: $white;

    @include laptop {
      max-width: 100%;
    }

    @include phone {
      font-size: 16px;
      line-height: 120%;
      margin-bottom: 20px;
    }
  }

  &__form {
    z-index: 2;
    flex: 0 0 730px;
    // background-color: rgba(36, 42, 48, 0.9);
    background-color: #323232;
    border-bottom-right-radius: 240px;
    padding: 104px 172px 112px 112px;
    padding: 60px 120px;
    margin-left: auto;

    @include laptop {
      flex: none;
      height: auto;
      margin-left: 0;
    }

    @include phone {
      // background-color: transparent;
      border-bottom-right-radius: 70px;
      padding: 26px 30px 60px;
    }
  }

  &__radio {
    width: 102px;

    @include phone {
      display: flex;
      max-width: 80px;
      width: 100%;
    }
  }

  &__check {
    width: 100%;
    margin: 10px 0 32px;

    a {
      text-decoration: underline;
      text-underline-offset: 2px;
    }
  }

  &__background-image {
    z-index: 1;
    position: relative;
    overflow: hidden;

    @include absolute-fill;

    img {
      width: 100%;
      height: 100%;

      @include object-fit(cover, center);
      @include lazy-loaded;
    }

    &::after {
      @include absolute-fill;

      content: "";
      background: linear-gradient(0deg, rgba(46, 48, 52, 0.3), rgba(46, 48, 52, 0.3));

      @include phone {
        background: linear-gradient(0deg,
            rgba(46, 48, 52, 0.95) 20%,
            rgba(46, 48, 52, 0.6) 50%,
            rgba(46, 48, 52, 0.3) 0%);
      }
    }
  }

  ._invalid {
    color: red;
    padding-top: 8px;
  }
}
</style>